import apiService from 'src/enviroment';
import { loaderService } from 'src/services/loaderService';

const getHistories = async (input) => {
  loaderService.show();
  const response = await apiService.get(
    `insights/admin/entradas/sistema/?tipo=portal_principal&filtro=${input}`,
  );
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const getSugerence = async () => {
  const response = await apiService.get('insights/admin/entradas/sistema/?tipo=sugerencias&filtro=prueba');
  try {
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

const getUnitHistory = async (id) => {
  loaderService.show();
  try {
    const response = await apiService.get(`insights/admin/entradas/sistema/?tipo=unidad_negocio&id_unidad=${id}`);
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

export { getHistories, getSugerence, getUnitHistory };
